import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Chip, Text } from '@frontend/design-system';
import { aiChipContainerStyles, textStyles } from './styles';

export const AIOverviewChip = () => {
  const { t } = useTranslation('fax');
  return (
    <div css={aiChipContainerStyles}>
      <Text weight='bold' css={textStyles}>
        {t('Weave AI Fax Overview')}
      </Text>
      <Chip css={{ backgroundColor: theme.colorsV2.indigo50() }}>
        <Text size='small' weight='regular' css={{ color: theme.colors.white }}>
          {t('Beta')}
        </Text>
      </Chip>
    </div>
  );
};
